const MAX_PRISE = 900000;

export { MAX_PRISE };
